const openInNewTab = (href: string): void => {
  Object.assign(document.createElement('a'), {
    href,
    target: '_blank',
  }).click();
};

export default openInNewTab;
